import { DatabaseOutlined, ReconciliationOutlined, HomeOutlined, InfoCircleOutlined, PictureOutlined } from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";

const dashBoardNavTree = [
  {
    key: "base",
    path: `${APP_PREFIX_PATH}`,
    title: "sidenav.base",
    icon: DatabaseOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "dashboard",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.dashboard",
        icon: HomeOutlined,
        breadcrumb: false,
        submenu: [],
      },

      //************************************************************************* */

      //************************************************************************* */

      {
        key: "consulta",
        path: `${APP_PREFIX_PATH}/bookings`,
        title: "sidenav.bookings",
        icon: ReconciliationOutlined,
        breadcrumb: false,
        submenu: [],
        opened: false,
      },
      {
        key: "info",
        path: `${APP_PREFIX_PATH}/information`,
        title: "sidenav.information",
        icon: InfoCircleOutlined,
        breadcrumb: false,
        submenu: [],
        opened: false,
      },
      {
        key: "equipments",
        path: `${APP_PREFIX_PATH}/equipments`,
        title: "sidenav.equipments",
        icon: PictureOutlined,
        breadcrumb: false,
        submenu: [],
        opened: false,
      },
    ],
  },
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
